import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'replaceCommas',
    standalone: false
})

export class ReplaceCommas implements PipeTransform {
  transform(value: string): string {
    return value.replace(/,/g, '.');
  }
}
